import { Icon, type IconSize } from "../icon";

export interface ButtonSpinnerProps {
  /** Icon size token. Defaults to "sm" (20px). */
  size?: IconSize;
}

/** Decorative spinner reserved for loading button states. */
function ButtonSpinner({ size = "sm" }: ButtonSpinnerProps) {
  return (
    <span className="aw-spinner inline-flex" aria-hidden="true">
      <Icon name="button-load-spinner" size={size} tone="inherit" />
    </span>
  );
}

export { ButtonSpinner };
